import { ReactNode } from 'react';

interface ContentContainerProps {
  children: ReactNode;
  className?: string;
}

export const ContentContainer = ({
  children,
  className = ''
}: ContentContainerProps) => {
  return (
    <div className={`w-full h-full rounded-lg ${className}`}>
      {children}
    </div>
  );
};
